import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import MainContainer from './containers/MainContainer';
import { AccountServiceApi } from './service';
import {useLocation} from "react-router-dom";
import { loggedInValue } from './access/access';

function App() {
  const dispatch = useDispatch();
  const [apiCallFinished, setApiCallFinished] = useState(0);
  const [error, setError] = useState();
  
  // const errorFound = useSelector(state => state.errorFound);
  // const errorMessage = useSelector(state => state.errorMessage);

  let location = useLocation();

  console.log("App.js");
  
  useEffect(() => {
    let mounted = true;
    // if (loggedInValue() === null) {
    //   window.open("/api/authorization/oidc", "_self");
    // }
    if(location.pathname !== "/login" && location.pathname !== "/expired") {
      const accountServiceApi = new AccountServiceApi();
      accountServiceApi.getAccount((error, userData) => {
        console.log("get account response")
        if (mounted) {
          if (!error) {
            console.log("Account details: ", userData);
            userTypeHandler(userData);
            setAccountDetailsHandler(userData);
            setApiCallFinished(apiCallFinished + 1);
          } else {
            setError(() => {
              throw new Error ("");
              // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
            })
          }
        }
      });
    }

    return () => {
      mounted = false;
    }
  }, []);

  console.log("apiCallFinished ", apiCallFinished)

  // useEffect(() => {
  //   if (errorFound) {
  //     setErrorDetailsHandler(false, "");
  //     console.log("errorMessage ", errorMessage);
  //     throw new Error(errorMessage)
  //   }
  // }, [errorFound]);

  // Redux
  const setAccountDetailsHandler = (data) => {
    dispatch({ type: 'setAccountDetails', userData: data});
  }

  // const makeSuperuserHandler = (data) => {
  //   console.log(data)
  //   dispatch({ type: 'makeSuperuser', userData: data });
  // }

  // Session storage
  const userTypeHandler = (data) => {
    let isSuperUser = false;
    let isStandardUser = false;
    for (const el of data.authorities) {
      if (el.type === "SU") {
        isSuperUser = true;
      }
      if (el.type === "ST") {
        isStandardUser = true;
      }
    }

    if (isSuperUser) {
      sessionStorage.setItem("isSuperuser", JSON.stringify(true));
    } else {
      sessionStorage.setItem("isSuperuser", JSON.stringify(false));
    }
    if (isStandardUser) {
      sessionStorage.setItem("isStandardUser", JSON.stringify(true));
    } else {
      sessionStorage.setItem("isStandardUser", JSON.stringify(false));
    }
  }

  return (
    <div className="App textColor">
    <MainContainer initialApiCallFinished={apiCallFinished}/>
    </div>
  );
}

export default App;